"use client";

/**
 * MenuBar — the persistent top bar of the terminal OS shell.
 *
 * Left:   the Ito mark (a home link) and the active-app switcher.
 * Right:  the time-zone clock and the account/session controls. (Themes switch
 *         from the command palette's "Theme…" command, not the menu bar.)
 *
 * The workspace tab strip renders directly BELOW this bar (owned by
 * `TerminalShell`), so the tab bar is part of the frame rather than a card
 * floating in the page.
 */

import { Link } from "@tanstack/react-router";

import { AuthStatus } from "../auth/auth-status";
import { AppSwitcher } from "./app-switcher";
import { ItoMark } from "./ito-mark";
import { TimeZoneClock } from "./time-zone-clock";

export function MenuBar() {
  return (
    <header className="flex h-9 shrink-0 items-center gap-1 border-b bg-background/95 px-2 text-xs">
      <Link
        to="/"
        aria-label="Ito Research home"
        className="mr-0.5 inline-flex items-center rounded-sm p-1 transition-opacity hover:opacity-80 focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none"
      >
        <ItoMark className="size-5" />
      </Link>
      <AppSwitcher />
      <div className="flex-1" />
      <TimeZoneClock />
      <AuthStatus />
    </header>
  );
}
